<template>
  <div>
    <div v-if="isCorrect">
      <v-img
          eager
          min-width="24"
          max-width="24"
          aspect-ratio="1"
          :src="require('../assets/correct.png')"
          class="user-select-none"
      ></v-img>
    </div>
    <div v-else>
      <v-img
          eager
          min-width="24"
          max-width="24"
          aspect-ratio="1"
          :src="require('../assets/incorrect.png')"
          class="user-select-none"
      ></v-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "ValidatorIcon",
  props: {
    isCorrect: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>